<template>
  <div>
    <!-- If NOT deposit account -->
    <div class="mb-5 text-center showDepositDetails">
      <div class="small-container pb-5">
        <div class="text-left mb-4">
          <h3>Leieforholdet</h3>
          <p>Registrer opplysninger om leieforholdets form, varighet og brutto husleie.</p>
        </div>

        <!-- Tenant Type -->
        <div class="row mt-5">
          <div class="col">
            <hl-RadioButtonTapWithIcon
              iconClass="budicon-hourglass"
              v-model="durationType"
              radioValue="limited"
            >
              <p>Leieforholdet er</p>
              <p class="font-weight-bold">tidsbestemt</p>
            </hl-RadioButtonTapWithIcon>
          </div>

          <div class="col">
            <hl-RadioButtonTapWithIcon
              iconClass="budicon-forward-time"
              v-model="durationType"
              radioValue="unlimited"
            >
              <p>Leieforholdet er</p>
              <p class="font-weight-bold">tidsubestemt</p>
            </hl-RadioButtonTapWithIcon>
          </div>
        </div>
        <!-- / Tenant Type -->
        <!-- Duration intervals -->
        <div class="row mt-5">
          <div class="col-12 col-md-6">
            <hl-Datepicker
              label="Kontrakten gjelder fra"
              v-model="depAccount.rent.startDate"
              name="rent.startDate"
              @input="setRentEndDate"
              v-validate
            ></hl-Datepicker>
          </div>

          <div class="col-12 col-md-6 mt-4 mt-md-0">
            <hl-Datepicker
              v-if="depAccount.rent.durationType === 'limited'"
              label="Kontrakten gjelder til"
              v-model="depAccount.rent.endDate"
              name="rent.endDate"
              v-validate
            ></hl-Datepicker>
          </div>
        </div>
        <!-- / Duration intervals -->
        <div class="row mt-4 mb-5 pb-3">
          <div class="col-12 col-md-6">
            <hl-Input
              type="number"
              label="Husleie (inkl. evt. tillegg) per måned"
              placeholder="kr"
              v-model="depAccount.rent.rent"
              name="rent.rent"
              v-validate
            />
          </div>
        </div>

        <div class="text-left mt-5 pt-3">
          <h3>{{ translationDepositAccountHeading }}</h3>
          <p>{{ translationDepositAccountNoOfMonthsCopy }}</p>
        </div>

        <!-- Number of months for deposit -->
        <div class="row row-equal-height mt-5 mb-5">
          <div class="col-12 col-md-6 text-left">
            <div class="box-container">
              <p class="font-weight-bold">
                {{ depAccount.deposit.ownDefined ? 'Egendefinert beløp' : 'Antall måneder depositum' }}
              </p>
              <div v-if="!depAccount.deposit.ownDefined">
                <div class="row months mt-5">
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="1"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>1</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="2"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>2</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="3"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>3</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                </div>

                <div class="row months mt-4">
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="4"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>4</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="5"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>5</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                  <div class="col">
                    <hl-RadioButtonTapWithIcon
                      v-model="depAccount.deposit.months"
                      radioValue="6"
                      layout="vertical"
                      iconClass="none"
                      :disabled="depAccount.deposit.noDeposit"
                    >
                      <p>6</p>
                    </hl-RadioButtonTapWithIcon>
                  </div>
                </div>
              </div>

              <div class="row mt-5">
                <div class="col">
                  <hl-Checkbox
                    label="Egendefinert beløp"
                    v-model="depAccount.deposit.ownDefined"
                    @input="setOwnDefined"
                  ></hl-Checkbox>
                </div>
              </div>
              <div v-if="depAccount.deposit.ownDefined" class="row mt-4">
                <div class="col">
                  <hl-Input
                    type="number"
                    v-model="depAccount.deposit.ownDefinedAmount"
                    placeholder="Ditt eget depositumsbeløp"
                    label="Beløp"
                    name="deposit.ownDefinedAmount"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 mt-4 mt-md-0 text-left">
            <div class="box-container bg-light h-100">
              <p v-if="!depAccount.deposit.ownDefined" class="font-weight-bold">Kalkulert depositumsbeløp</p>
              <p v-else class="font-weight-bold">Egendefinert depositumsbeløp</p>

              <div class="text-center mt-5">
                <i class="budicon-savings" style="font-size: 3em"></i>
                <h5 class="mt-3">{{ toCurrency('NOK', calcDeposit) }}</h5>
                <p v-if="depAccount.deposit.ownDefined">Egendefinert</p>
                <div v-else-if="isDepositProductOfMonthlyRent">
                  <span>{{ toCurrency('NOK', depAccount.rent.rent) }}</span>
                  <span> x {{ translationMonths }} </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="alert alert-warning" role="alert" v-if="isDepositTooLow">
          OBS! Skulle du velge Premium-abonnement (med utleieforsikring) kreves det et depositum som tilsvarer minimum
          tre måneders husleie.
        </div>
        <!-- / Number of months for deposit -->
      </div>

      <hl-NextBackBottomBar
        buttonSize="lg"
        backText="tilbake"
        backLink="tenant"
        :nextLink="getNextLink"
        nextText="neste"
      />
    </div>
    <!-- /If NOT deposit account -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Input from '@/components/Input.vue';
import NextBackBottomBar from '@/components/NextBackBottomBar.vue';
import Checkbox from '@modules/husleie-framework/src/components/forms/inputs/checkbox/Checkbox.vue';
import Datepicker from '@modules/husleie-framework/src/components/forms/inputs/Datepicker.vue';
import RadioButtonTapWithIcon from '@modules/husleie-framework/src/components/forms/inputs/radio-buttons/RadioButtonTapWithIcon.vue';
import hlValidateBeforeLeave from '@modules/husleie-framework/src/mixins/hlValidateBeforeLeave';
import i18nCommon from '@modules/i18n/mixins/Common';
import * as moment from 'moment';

export default {
  mixins: [hlValidateBeforeLeave, i18nCommon],

  props: {
    depAccount: Object,
    contract_id: String,
    isSubscriptionBasic: Boolean,
    isSubscriptionPremium: Boolean,
    isSubscriptionPro: Boolean,
  },

  components: {
    'hl-RadioButtonTapWithIcon': RadioButtonTapWithIcon,
    'hl-Datepicker': Datepicker,
    'hl-Checkbox': Checkbox,
    'hl-Input': Input,
    'hl-NextBackBottomBar': NextBackBottomBar,
  },

  mounted() {
    /* GTM Tracking */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: '/depositaccount/step2/deposit',
      virtualPageTitle: 'Deposit Account | Step 2 | Deposit',
    });
  },

  updated() {
    this.$emit('updated');
  },

  computed: {
    ...mapGetters('common/features', ['getFeature']),

    durationType: {
      get() {
        return this.depAccount.rent.durationType;
      },
      set(value) {
        this.depAccount.rent.durationType = value;

        /* Small fix for a vee-validate error that happens when the endDate field
         * gets hidden due to `durationType` change.
         */
        setTimeout(() => {
          this.depAccount.rent.endDate = undefined;
        }, 500);
      }
    },
    calcDeposit() {
      if (this.depAccount.deposit.ownDefined) {
        return this.depAccount.deposit.ownDefinedAmount;
      } else {
        const calc = this.depAccount.rent.rent * this.depAccount.deposit.months;
        return calc;
      }
    },
    getNextLink() {
      const isPlanDisabled = this.getFeature('tenancySubscripition').isDisabled;
      return (isPlanDisabled || this.depAccount.hasSubscription) ? 'sign' : 'plan';
    },
    isDepositTooLow() {
      const isCustomDepositLessThanThreeTimesRent =
        this.depAccount.deposit.ownDefined &&
        this.depAccount.rent.rent &&
        this.calcDeposit &&
        this.depAccount.rent.rent * 3 > this.calcDeposit;
      const isSetDepositLessThanThreeMonths = !this.depAccount.deposit.ownDefined && this.depAccount.deposit.months < 3;

      return isCustomDepositLessThanThreeTimesRent || isSetDepositLessThanThreeMonths;
    },
    isDepositProductOfMonthlyRent() {
      return this.depAccount.deposit.months > 1;
    },
    translationDepositAccountHeading() {
      return this.translate('deposit.heading');
    },
    translationDepositAccountNoOfMonthsCopy() {
      return this.translate('deposit.number of months deposit information');
    },
    translationMonths() {
      return this.translatePlural('month', this.depAccount.deposit.months);
    },
  },

  watch: {
    'depAccount.rent.rent': {
      handler() {
        this.depAccount.deposit.calcDeposit = this.calcDeposit;
      },
      immediate: true,
    },

    'depAccount.deposit.months': {
      handler() {
        this.depAccount.deposit.calcDeposit = this.calcDeposit;
      },
      immediate: true,
    },

    'depAccount.deposit.ownDefinedAmount': {
      handler() {
        this.depAccount.deposit.calcDeposit = this.calcDeposit;
      },
      immediate: true,
    },
  },

  methods: {
    setOwnDefined() {
      if (!this.depAccount.deposit.ownDefined) {
        this.depAccount.deposit.ownDefinedAmount = '';
      }
    },

    setRentEndDate(d) {
      if (this.depAccount.rent.durationType === 'limited') {
        this.depAccount.rent.endDate = moment(d).add(3, 'y').subtract(1, 'days').format('YYYY-MM-DD');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box-container {
  border: 1px solid $gray-400;
  padding: 30px;
  border-radius: $border-radius;
}

// custom checkbox
/* Hide the browser's default checkbox */
.form-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  background-color: #fff;
  border: 2px solid $gray-500;
  border-radius: $border-radius;
  transition: $transition-base;
}

.checkmark-lg {
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
}

.checkmark-sm {
  top: 3px;
  left: 0;
  height: 15px;
  width: 15px;
}

.form-check input:disabled ~ .checkmark {
  background: #fff !important;
  background-image: url('../../../modules/husleie-framework/icons/custom/dash.svg') !important;
  color: pink;
  background-size: 12px !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  border: 2px solid $gray-400 !important;
}

/* On mouse-over, add a grey background color */
.form-check:hover input ~ .checkmark {
  border: 2px solid $primary;
}

/* When the checkbox is checked, add a blue background */
.form-check input:checked ~ .checkmark {
  background-color: $primary;
  border: 2px solid $primary;
  background-image: url('../../../modules/husleie-framework/icons/custom/checkmark.svg');
  background-size: 12px;
  background-position: center center;
  background-repeat: no-repeat;
}

// end of custom checkbox
</style>
